import Icon from 'veui/components/Icon'
import { IconCaretLeft } from 'dls-icons-vue'

Icon.register('caret-left', IconCaretLeft)
